<template>
    <div class="presetContainer">
        <h4>{{editable ? 'Filter hinzufügen' : 'Filter Einstellungen'}}</h4>
        <!--<transition-group name="fade">-->
        <PresetFilterRow :columns="columns" :showAdd="true" :editable="editable"
                         :initialize="initialize" :initial="columns[0]"
                         @add="addFilter" @selected="filterSelected" @input="updateFilterValue"
        ></PresetFilterRow>
        <!--</transition-group>-->
        <PresetResult :editable="editable" :columns="data" @update="updateFilterValue" :key="key"></PresetResult>
    </div>
</template>

<script>
    import PresetFilterRow from "./PresetFilterRow";
    import PresetResult from "./PresetResult";
    import Utils from "../../../../scripts/utils";

    export default {
        name: "PresetFilter",
        components: {PresetResult, PresetFilterRow},
        props: {
            columns: {
                type: Array,
                required: true
            },
            initialize: { //render with initial values
                type: Boolean,
                default: true
            },
            editable: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                data: [], //filter contents,
                key: 0,
            }
        },
        mounted() {
            this.validColumns();
        },
        computed: {},
        methods: {
            filterSelected(selected) {
                if (typeof this.data[selected.index] === "undefined") {
                    this.data.push(selected.data);
                } else {
                    this.data[selected.index] = selected.data;
                }
                this.$emit('update', this.data);
            },
            updateFilterValue(data) {
                if (data.column) {
                    if (typeof this.data.find(x => x.id === data.column.id) !== "undefined") {
                        let index = this.data.findIndex(x => x.id === data.column.id);
                        if (Array.isArray(data.filter_value) && data.filter_value.length === 0) {
                            this.data.splice(index, 1);
                        } else {
                            this.data[index].pivot.filter_value = data.filter_value;
                        }
                        this.$emit('update', this.data);
                        this.key++;
                    }
                }
            },
            addFilter(data) {
                let index = this.data.findIndex(x => x.id === data.column.id);
                if (index !== -1) {
                    if (typeof this.data[index].pivot.filter_value !== "undefined") {
                        let filter_value = Utils.toArray(this.data[index].pivot.filter_value);
                        filter_value = filter_value.concat(data.filter_value);
                        this.data[index].pivot.filter_value = filter_value;
                    } else {
                        this.data.push(this.createNewFilter(data));
                        this.data.sort(this.sortByDisplayName);
                    }
                } else {
                    this.data.push(this.createNewFilter(data));
                    this.data.sort(this.sortByDisplayName);
                }
                this.key++;
                this.$emit('update', this.data);
            },
            sortByDisplayName(a, b) {
                if (a.display_name < b.display_name) {
                    return -1;
                }
                if (a.display_name > b.display_name) {
                    return 1;
                }
                return 0;
            },
            createNewFilter(data) {
                let ret = data.column;
                ret.pivot.filter_value = data.filter_value;
                return ret;
            },
            validColumns() {
                //render only those where filter_value !== null but at least 1
                this.data = [];
                if (this.initialize) {
                    this.columns.forEach((col) => {
                        //if ((typeof col.pivot !== "undefined" && col.pivot.filter_value !== null) || Object.keys(col).length === 0) {
                        this.data.push(col);
                        //}
                    });
                }
                //if (this.data.length === 0) this.data.push({});
            }
        },
        watch: {
            columns() {
                this.validColumns();
            }
        },
    }
</script>

<style scoped>
    .presetContainer {
        margin-top: 40px;
        margin-bottom: 10px;
    }

    h4 {
        margin-bottom: 10px;
    }
</style>